import { createAction } from 'redux-actions'
import * as types from 'Redux/Types/VendorTypes'

export const addVendorAlias = createAction(types.ADD_VENDOR_ALIAS)
export const addVendorAliasFailed = createAction(types.ADD_VENDOR_ALIAS_FAILED)
export const addVendorAliasSucceeded = createAction(types.ADD_VENDOR_ALIAS_SUCCEEDED)
export const addVendorTag = createAction(types.ADD_VENDOR_TAG)
export const addVendorTagFailed = createAction(types.ADD_VENDOR_TAG_FAILED)
export const addVendorTagSucceeded = createAction(types.ADD_VENDOR_TAG_SUCCEEDED)
export const changeVendorAlias = createAction(types.CHANGE_VENDOR_ALIAS)
export const changeVendorAliasFailed = createAction(types.CHANGE_VENDOR_ALIAS_FAILED)
export const changeVendorAliasSucceeded = createAction(types.CHANGE_VENDOR_ALIAS_SUCCEEDED)
export const changeVendorTag = createAction(types.CHANGE_VENDOR_TAG)
export const changeVendorTagFailed = createAction(types.CHANGE_VENDOR_TAG_FAILED)
export const changeVendorTagSucceeded = createAction(types.CHANGE_VENDOR_TAG_SUCCEEDED)
export const deleteVendorAlias = createAction(types.DELETE_VENDOR_ALIAS)
export const deleteVendorAliasFailed = createAction(types.DELETE_VENDOR_ALIAS_FAILED)
export const deleteVendorAliasSucceeded = createAction(types.DELETE_VENDOR_ALIAS_SUCCEEDED)
export const deleteVendorTag = createAction(types.DELETE_VENDOR_TAG)
export const deleteVendorTagFailed = createAction(types.DELETE_VENDOR_TAG_FAILED)
export const deleteVendorTagSucceeded = createAction(types.DELETE_VENDOR_TAG_SUCCEEDED)
export const fetchVendorAliases = createAction(types.FETCH_VENDOR_ALIASES)
export const fetchVendorAliasesFailed = createAction(types.FETCH_VENDOR_ALIASES_FAILED)
export const fetchVendorAliasesSucceeded = createAction(types.FETCH_VENDOR_ALIASES_SUCCEEDED)
export const getRecentVendors = createAction(types.GET_RECENT_VENDORS)
export const getRecentVendorsFailed = createAction(types.GET_RECENT_VENDORS_FAILED)
export const getRecentVendorsSucceeded = createAction(types.GET_RECENT_VENDORS_SUCCEEDED)
export const getVendors = createAction(types.GET_VENDORS)
export const getVendorsFailed = createAction(types.GET_VENDORS_FAILED)
export const getVendorsSucceeded = createAction(types.GET_VENDORS_SUCCEEDED)
export const resetVendorFilters = createAction(types.RESET_VENDOR_FILTERS)
export const toggleVendorFilterDrawer = createAction(types.TOGGLE_VENDOR_FILTER_DRAWER)

export const fetchVendors = createAction(types.FETCH_VENDORS)
export const fetchVendorsFailed = createAction(types.FETCH_VENDORS_FAILED)
export const fetchVendorsSucceeded = createAction(types.FETCH_VENDORS_SUCCEEDED)
